module.exports = __webpack_public_path__ + "static/media/adhesive_labels.ce6b8e22.jpg";